import React, { useState } from 'react';
import { Icon, Box } from '@blueprint/ui';

const ScrollToTopComponent = () => {
    const [showScroll, setShowScroll] = useState(false);

    const checkScrollTop = () => {
        if (!showScroll && window.pageYOffset > 10) {
            setShowScroll(true);
        } else if (showScroll && window.pageYOffset <= 10) {
            setShowScroll(false);
        }
    };

    const scrollTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        let elementsWithError = document.getElementsByClassName('page-title');
        setTimeout(() => {
            console.log('Logging Page title before if condition', elementsWithError);
            if (elementsWithError !== null && elementsWithError !== undefined && elementsWithError.length > 0) {
                console.log('Logging Page title', elementsWithError[0]);
                elementsWithError[0].focus();
            }
        }, 400);
    };

    window.addEventListener('scroll', checkScrollTop);

    return (
        <Box
            role='button'
            tabIndex='0'
            aria-label='Click here to Scroll to top'
            style={{
                width: '30px',
                height: '30px',
                backgroundColor: 'white',
                display: showScroll ? 'flex' : 'none',
                position: 'fixed',
                top: '90vh',
                right: '5vw',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                border: '1px solid black',
                boxShadow: '0px 0px 10px grey',
                zIndex: '1000',
            }}
            onClick={scrollTop}
            onKeyDown={(event) => {
                console.log('Logging event onKeyDown event.keyCode', event.keyCode);
                if (event.keyCode === 13) {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                    let elementsWithError = document.getElementsByClassName('page-title');
                    setTimeout(() => {
                        console.log('Logging Page title before if condition', elementsWithError);
                        if (elementsWithError !== null && elementsWithError !== undefined && elementsWithError.length > 0) {
                            console.log('Logging Page title', elementsWithError[0]);
                            elementsWithError[0].focus();
                        }
                    }, 400);
                }
            }}
        >
            <Icon name='ChevronUp' />
        </Box>
    );
};

export default ScrollToTopComponent;
